import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// === Early performance optimizations (runs before React mounts) ===
// 1. Preload hero image so browser discovers it immediately (fixes LCP discovery)
const preloadLink = document.createElement('link');
preloadLink.rel = 'preload';
preloadLink.as = 'image';
preloadLink.href = 'https://cdn.magicpatterns.com/uploads/7JqcfQigPgCUz8cnpAX8jJ/mockup_final_dormir_mejor_desde_el_amor.png';
preloadLink.setAttribute('fetchpriority', 'high');
document.head.appendChild(preloadLink);
// 2. Add preconnect for image CDN
const cdnPreconnect = document.createElement('link');
cdnPreconnect.rel = 'preconnect';
cdnPreconnect.href = 'https://cdn.magicpatterns.com';
cdnPreconnect.crossOrigin = 'anonymous';
document.head.insertBefore(cdnPreconnect, document.head.firstChild);
// 3. Remove render-blocking Google Fonts (injected by platform, not used)
document.querySelectorAll('link').forEach(link => {
  const href = link.getAttribute('href') || '';
  if (href.includes('fonts.googleapis.com') || href.includes('fonts.gstatic.com')) {
    link.remove();
  }
});
// === Mount React app ===
render(<App data-id="element-182" />, document.getElementById('root'));